export const directives = `
scalar AWSDate
scalar AWSTime
scalar AWSDateTime
scalar AWSTimestamp
scalar AWSEmail
scalar AWSJSON
scalar AWSURL
scalar AWSPhone
scalar AWSIPAddress
scalar BigInt
scalar Double

directive @aws_subscribe(mutations: [String!]!) on FIELD_DEFINITION

# Allows transformer libraries to deprecate directive arguments.
directive @deprecated(reason: String) on FIELD_DEFINITION | INPUT_FIELD_DEFINITION | ENUM | ENUM_VALUE

directive @aws_auth(cognito_groups: [String!]!) on FIELD_DEFINITION
directive @aws_api_key on FIELD_DEFINITION | OBJECT
directive @aws_iam on FIELD_DEFINITION | OBJECT
directive @aws_oidc on FIELD_DEFINITION | OBJECT
directive @aws_cognito_user_pools(cognito_groups: [String!]) on FIELD_DEFINITION | OBJECT
`;

export const cognitoTypes = `

type ListUserAuthEventPayload {
  AuthEvents: [UserAuthEvent!]!
  NextToken: String
}

type UserAuthEvent {
  EventId: String!
  EventType: UserAuthEventType!
  CreationDate: AWSDate!
  EventResponse: UserAuthEventResponse!
  EventRisk: UserAuthEventRisk!
}

type EventContextData {
  IpAddress: String!
  DeviceName: String!
  Timezone: String!
  City: String!
  Country: String!
}

type UserAuthEventRisk {
  RiskDecision: String
  RiskLevel: UserAuthEventRiskLevel
  CompromisedCredentialsDetected: Boolean
}

enum UserAuthEventRiskLevel {
  Low
  Medium
  High
}

enum UserAuthEventResponse {
  Success
  Failure
}

enum UserAuthEventType {
  SignIn
  SignUp
  ForgotPassword
}

input ListUserAuthEventsWhereInput {
  Username: String
}

input ListUsersByGroupWhereInput {
  GroupName: String
}

input ListGroupsByUserInput {
  Username: String
}

input AdminSetUserPasswordWhere {
  Username: String!
}

input AdminSetUserPasswordInput {
  Password: String!
  Permanent: Boolean
}

input AdminResetUserPasswordWhere {
  Username: String!
}

input AddOrRemoveUserFromGroupInput {
  Username: String!
  GroupName: String!
}

input AdminLogoutUserInput {
  Username: String
}

input AdminEnableUserInput {
  Username: String!
}

input AdminDisableUserInput {
  Username: String!
}

input AdminConfirmSignUpInput {
  Username: String!
}

input AdminDeleteUserInput {
  Username: String!
}

input AdminCreateUserInput {
  Username: String!
  UserAttributes: [ValueInput]
}

input ValueInput {
  Name: String!
  Value: String
}

type ListUserResultPayload {
  Users: [User]
  NextToken: String
}

type UserDeletePayload {
  OK: Boolean!
}

input UserWhereUniqueInput {
  Username: String!
}

type User {
  Username: String!
  UserAttributes: [Value]
  UserCreateDate: String
  UserLastModifiedDate: String
  Enabled: Boolean
  UserStatus: UserStatus
  MFAOptions: [MFAOption]
  PreferredMfaSetting: String
  UserMFASettingList: String
  Groups: [CognitoGroup]
}
type Value {
  Name: String!
  Value: String
}
type MFAOption {
  DeliveryMedium: String
  AttributeName: String
}
enum UserStatus {
  UNCONFIRMED
  CONFIRMED
  ARCHIVED
  COMPROMISED
  UNKNOWN
  RESET_REQUIRED
  FORCE_CHANGE_PASSWORD
}

type CognitoGroup {
  GroupName: String!
  UserPoolId: String!
  RoleArn: String!
  Precedence: String!
  LastModifiedDate: AWSDateTime!
  CreationDate: AWSDateTime!
}
`;

enum AuthProvider {
  apiKey = "apiKey",
  iam = "iam",
  oidc = "oidc",
  userPools = "userPools",
}
enum AuthStrategy {
  owner = "owner",
  groups = "groups",
  private = "private",
  public = "public",
}

enum AuthModelOperation {
  create = "create",
  update = "update",
  delete = "delete",
  read = "read",
}

enum AuthModelMutation {
  create = "create",
  update = "update",
  delete = "delete",
}

export const enums = {
  AuthProvider,
  AuthStrategy,
  AuthModelMutation,
  AuthModelOperation,
};
